// T051 — Claim initiated event definition.

import type { EventDefinition } from './navigation';

export type ClaimInitiatedProperties = {
  marketPubkey: string;
  outcomeIndex: number;
  claimableAmount: number;
};

export const CLAIM_INITIATED: EventDefinition<ClaimInitiatedProperties> = {
  name: 'claim_initiated',
};
